const accountName = require('./account-name');
const assignedPortal = require('./assigned-portal');
const catering = require('./catering');
const cateringDietaryRestrictions = require('./catering_dietary_restrictions');
const countries = require('./countries');
const credentials = require('./credentials');
const date = require('./date');
const time = require('./time');
const datetime = require('./datetime');
const dropdown = require('./dropdown');
const eventDays = require('./event-days');
const file = require('./file');
const inventory = require('./inventory');
const reference = require('./reference');
const percent = require('./percent');
const currency = require('./currency');
const source = require('./source');
const user = require('./user');
const lookup = require('./lookup');
const checkbox = require('./checkbox');
const text = require('./text');
const catalogItem = require('./catalog-item');
const approval = require('./approval');
const eventList = require('./event-list');
const accountList = require('./account-list');
const peopleBlock = require('./people-block');
const primaryContacts = require('./primary-contacts');
const documentRequest = require('./document-request');
const healthPass = require('./health-pass');
const form = require('./form');
const task = require('./task');
const applicationForm = require('./application-form');
const payment = require('./payment');
const itemGroup = require('./item-group');
const itemBlock = require('./item-block');
const allocatedItems = require('./allocated-items');
const schedule = require('./schedule');
const eventUsers = require('./event-users');
const emsStatus = require('./ems-status');
const hasPortalAccess = require('./has-portal-access');
const number = require('./number');
const zone = require('./zone');
const fuzzyDropdown = require('./fuzzy_dropdown');
const speakers = require('./speakers');

/**
 * @param  {Object} value
 * @param  {String} type
 * @param  {Object} eventDetails
 * @param  {Object} meta         Object containing any metadata the to-string
 *  functions might need. EventDetails could be in here but for backwards
 *  compatability, leaving it out for now.
 * @return {String}
 */
module.exports = function (value, type, eventDetails = {}, meta = {}) {
  switch (type) {
    case 'dropdown':
    case 'multiple_select':
    case 'languages':
      return dropdown(value);
    case 'fuzzy-dropdown':
      return fuzzyDropdown(value, eventDetails, meta);
    case 'speakers':
      return speakers(value);
    case 'event-days':
      return eventDays(value, eventDetails);
    case 'credentials':
      return credentials(value, eventDetails, meta);
    case 'catalog-item':
      return catalogItem(value, meta);
    case 'countries':
      return countries(value);
    case 'catering':
      return catering(value);
    case 'catering_dietary_restrictions':
      return cateringDietaryRestrictions(value, eventDetails);
    case 'file':
      return file(value);
    case 'inventory':
    case 'inventory-list':
      return inventory(value);
    case 'date':
      return date(value, eventDetails);
    case 'time':
      return time(value, eventDetails);
    case 'datetime':
      return datetime(value, eventDetails, meta);
    case 'source':
      return source(value, meta);
    case 'reference':
      return reference(value);
    case 'currency':
      return currency(value, meta);
    case 'lookup':
      return lookup(value, meta);
    case 'percent':
      return percent(value, meta);
    case 'calculated-number':
      return percent(value, meta);
    case 'user':
      return user(value);
    case 'checkbox':
      return checkbox(value);
    case 'email':
    case 'textarea':
    case 'wysiwyg':
    case 'text':
    case 'signature':
      return text(value);
    case 'number':
      return number(value);
    case 'approval':
      return approval(value);
    case 'event-list':
      return eventList(value);
    case 'account-list':
      return accountList(value);
    case 'primary-contacts':
      return primaryContacts(value);
    case 'document-request':
      return documentRequest(value);
    case 'health-pass':
      return healthPass(value);
    case 'form':
      return form(value);
    case 'application-form':
      return applicationForm(value);
    case 'task':
      return task(value);
    case 'payment':
      return payment(value);
    case 'item-group':
      return itemGroup(value);
    case 'item-block':
      return itemBlock(value);
    case 'allocated-items':
    case 'allocated-passes':
    case 'allocated-meals':
      return allocatedItems(value);
    case 'schedule':
      return schedule(value);
    case 'people-block':
      return peopleBlock(value);
    case 'event-users':
      return eventUsers(value);
    case 'ems-status':
      return emsStatus(value);
    case 'account-name':
    case 'contact-name':
    case 'event-name':
      return accountName(value);
    case 'assigned-portal':
      return assignedPortal(value);
    case 'has-portal-access':
      return hasPortalAccess(value);
    case 'zone':
      return zone(value);
    default:
      return value;
  }
};
